import { useQuery } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';

export const useGetColumnSampleData = ({ tableId, columnName, config }) => {
  const { addNotification } = useNotificationStore();

  const queryKey = ['columnSampleData', tableId, columnName];
  return useQuery(
    queryKey,
    () =>
      axios.get(
        `/api/v1/integration/data-dictionaries/tables/${tableId}/columns/${columnName}/sample-values`
      ),
    {
      ...config,
      onError: (error) => {
        addNotification({ type: 'error', title: error.message });
      },
    }
  );
};
